<template>
  <div ref="container" class="nav-menu-container"
       :style="`${style.containerWidth?'width:'+style.containerWidth+'px;':''}`">
    <el-menu
        ref="elMenu"
        :default-active="routePath"
        class="d-flex-row align-items-center el-menu-demo animate__animated "
        :class="`${style.paddle==='left'?'animate__fadeInRight':'animate__fadeInLeft'}`"
        mode="horizontal"
        text-color="#595959"
        active-text-color="#E03F3D"
    >
      <template v-for="(menuItem,index) in navMenus">
        <template v-if="menuItem.children && menuItem.children.length">
          <el-submenu class="menu-item" :key="index" :index="menuItem.path"
                      v-if="menuItem.meta.auth === 'normal'?true:userAuth[menuItem.meta.auth]">
            <template slot="title">
              <i :class="[selectedMenu(menuItem,'top') ? (menuItem.meta.icon_active):menuItem.meta.icon]"/>
              {{ calcMenuTitle(menuItem, 'top') }}
            </template>
            <template v-for="(item,indx) in menuItem.children">
              <template v-if="item.children">
                <el-submenu :index='index+"-"+indx' :key="`${index}-${indx}`">
                  <template slot="title">
                    <i :class="[selectedMenu(item) ? (item.meta.icon_active):item.meta.icon]"/>
                    {{ calcMenuTitle(item) }}
                  </template>
                  <template v-for="(i,j) in item.children">
                    <el-menu-item @click="goRoute(i.path)"
                                  v-if="!(i.meta.hidden || !(i.meta.auth === 'normal'?true:userAuth[i.meta.auth]))"
                                  :key="j+'-'+j" :index="i.path">
                      <i :class="routePath === i.path ? (i.meta.icon_active):i.meta.icon"/>
                      {{ i.meta.title }}
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
              <template v-if="item.meta&&(!item.children)">
                <template v-if="item.meta.isExternal&&item.meta.link">
                  <el-menu-item v-if="!(item.meta.hidden || !(item.meta.auth === 'normal'?true:userAuth[item.meta.auth]))"
                                :key="index+'-'+indx" :index="item.path">
                    <a :href="item.meta.link" target="_blank">
                      <i :class="routePath === item.path ? (item.meta.icon_active):item.meta.icon"/>
                      {{ item.meta.title }}
                    </a>
                  </el-menu-item>
                </template>
                <template v-else>
                  <el-menu-item @click="goRoute(item.path)"
                                v-if="!(item.meta.hidden || !(item.meta.auth === 'normal'?true:userAuth[item.meta.auth]))"
                                :key="index+'-'+indx" :index="item.path">
                    <i :class="routePath === item.path ? (item.meta.icon_active):item.meta.icon"/>
                    {{ item.meta.title }}
                  </el-menu-item>
                </template>
              </template>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <template v-if="menuItem.meta">
            <!-- hidden=true 不存在菜单栏 auth = true 没有权限 不出现在菜单栏-->
            <el-menu-item @click="goRoute(menuItem.path)"
                          v-if="!(menuItem.meta.hidden || !(menuItem.meta.auth == 'normal'?true:userAuth[menuItem.meta.auth]))"
                          :key="index" :index="menuItem.path">
              <el-badge v-if="menuItem.name==='dashboard'" value="new" class="new-menu">
                <i :class="routePath === menuItem.path? (menuItem.meta.icon_active):menuItem.meta.icon"/>
              </el-badge>
              <i v-else :class="routePath === menuItem.path? (menuItem.meta.icon_active):menuItem.meta.icon"/>
              {{ calcMenuTitle(menuItem) }}
            </el-menu-item>
          </template>
        </template>
      </template>
    </el-menu>

    <div class="paddles">
      <a :class="`left-paddle paddle ${style.hiddenLeft?'hidden':''}`"
         :style="`left:${style.left}px;`"
         @click="handelPaddle('left')">
        <i class="el-icon-caret-left"/>
      </a>

      <a :class="`right-paddle paddle ${style.hiddenRight?'hidden':''}`"
         @click="handelPaddle('right')">
        <i class="el-icon-caret-right"/>
      </a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "NavMenu",
  computed: {
    ...mapGetters(['routePath']),
    user() {
      return this.$store.getters.getUser
    },
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    userPermissions() {
      return this.$store.getters.userPermissions
    }
  },
  data() {
    return {
      style: {
        paddle: 'right',
        containerWidth: 0,
        left: 0,
        hiddenLeft: true,
        hiddenRight: false,
      },
      screenWidth: document.body.clientWidth,
      navMenus: [
        {
          "path": "/home",
          "name": "home",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "首页",
            "icon": "el-icon-s-home",
            "icon_active": "el-icon-s-home",
            "auth": "home"
          }
        },
        {
          "path": "/notify",
          "name": "notify",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "消息通知",
            "icon": "el-icon-message-solid",
            "icon_active": "el-icon-message-solid",
            "auth": "notify"
          }
        },
        {
          "path": "/dashboard",
          "name": "dashboard",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "仪表盘",
            "icon": "el-icon-home",
            "icon_active": "el-icon-home-active",
            "auth": "dashboard_new"
          }
        },
        {
          "path": "/homeOld",
          "name": "homeOld",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "仪表盘",
            "icon": "el-icon-home",
            "icon_active": "el-icon-home-active",
            "auth": "dashboard"
          }
        },
        {
          "path": "/project/",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "基础资料",
            "icon": "iconfont icon-a-11Dguanbiwenjianjia",
            "icon_active": "iconfont icon-a-11Dguanbiwenjianjia",
            "auth": "basic_data"
          },
          "children": [
            // {
            //   "path": "/project/favouriteBoy",
            //   "name": "favouriteBoy",
            //   "meta": {
            //     "requiresAuth": true,
            //     "hidden": false,
            //     "title": "红人资料",
            //     "icon": "",
            //     "keepAlive": true,
            //     "auth": "manage_menu_artist_info"
            //   }
            // },
            {
              "path": "/project/favouriteBoyNew",
              "name": "favouriteBoyNew",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "红人资料",
                "icon": "",
                "keepAlive": true,
                "auth": "manage_menu_artist_info"
              },
            },
            {
              "path": "/project/customer",
              "name": "custom",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "客户相关",
                "icon": "",
                "auth": "manage_basic_customer_info",
                "keepAlive": true
              },
              "children": [
                {
                  "path": "/project/customer",
                  "name": "custom",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "客户资料",
                    "icon": "",
                    "auth": "manage_basic_customer_info",
                    "keepAlive": true
                  }
                },
                {
                  "path": "/project/myCustom",
                  "name": "myCustom",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "我的客户",
                    "icon": "",
                    "auth": "manage_menu_customer_info",
                    "keepAlive": true
                  }
                },
                {
                  "path": "/project/combine_customer",
                  "name": "combine",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "客户集团",
                    "icon": "",
                    "auth": "manage_basic_combine"
                  }
                },
                {
                  "path": "/volume/search",
                  "name": "volumeSearch",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "新客检测",
                    "icon": "",
                    "auth": "customer_detection_list"
                  }
                },
                {
                  "path": "/customer/pool",
                  "name": "customerPool",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "公海客户池",
                    "icon": "",
                    "auth": "customer_pool_list"
                  }
                },
                {
                  "path": "/customer/pool_task",
                  "name": "customerPoolTask",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "客户跟进",
                    "icon": "",
                    "auth": "customer_pool_task_list"
                  }
                },
              ]
            },
            {
              "path": "/project/yearFrameAuditor",
              "name": "yearFrameAuditor",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "年框相关",
                "auth": "manage_year_frame_audit"
              },
              "children": [
                {
                  "path": "/project/yearFrameAuditor",
                  "name": "yearFrameAuditor",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "年框审核",
                    "auth": "manage_year_frame_audit"
                  }
                },
                {
                  "path": "/project/yearFrameProposer",
                  "name": "yearFrameProposer",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": true,
                    "title": "年框申请列表",
                    "auth": "manage_year_frame_audit"
                  }
                },
                {
                  "path": "/project/yearFrameAck",
                  "name": "yearFrameAck",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "年框列表",
                    "auth": "year_frame_ack_list"
                  }
                },
                {
                  "path": "/project/yearFrameSchedule",
                  "name": "yearFrameSchedule",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "年框进度",
                    "auth": "year_frame_schedule_list"
                  }
                },
                {
                  "path": "/customer/level",
                  "name": "customerLevel",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "客户等级配置",
                    "icon": "",
                    "auth": "manage_basic_customer_level"
                  }
                },
                {
                  "path": "/customer/key_customer",
                  "name": "keyCustomer",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "重点客户",
                    "icon": "",
                    "auth": "key_customer"
                  }
                },
                {
                  "path": "/customer/key_customer_sale",
                  "name": "keyCustomerSale",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "重点客户（我）",
                    "icon": "",
                    "auth": "key_customer_sale"
                  }
                },
              ]
            },

            {
              "path": "/project/brand",
              "name": "brand",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "品牌资料",
                "icon": "",
                "auth": "manage_basic_brand"
              },
              children: [
                {
                  "path": "/project/brand",
                  "name": "brand",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "品牌资料",
                    "icon": "",
                    "auth": "manage_basic_brand"
                  }
                },
                {
                  "path": "/project/combine_brand",
                  "name": "combine",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "品牌集团",
                    "icon": "",
                    "auth": "manage_basic_combine_brand"
                  }
                },
                {
                  "path": "/brand/search",
                  "name": "brandSearch",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "品牌检索",
                    "icon": "",
                    "auth": "brand_search_list"
                  }
                },
                {
                  "path": "/brand/record",
                  "name": "brandRecord",
                  "meta": {
                    "requiresAuth": true,
                    "hidden": false,
                    "title": "品牌展示",
                    "icon": "",
                    "auth": "manage_brand_record"
                  }
                },

              ]
            },


            {
              "path": "/project/optionSet",
              "name": "optionSet",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "选项配置",
                "icon": "",
                "auth": "can_option_settings"
              }
            },
            {
              "path": "/order/discount",
              "name": "orderDiscount",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "折扣设置",
                "icon": "",
                "auth": "view_rebate_config"
              }
            },
            {
              "path": "/order/company",
              "name": "orderCompany",
              "meta": {
                "requiresAuth": true,
                "hidden": false,
                "title": "乙方配置",
                "icon": "",
                "auth": "can_option_settings"
              }
            }
          ]
        },
        {
          "path": "/ad_menu",
          "name": "ad-menu",
          "meta": {
            "title": "订单管理",
            "hidden": false,
            "icon": "el-icon-gg",
            "icon_active": "el-icon-gg-active",
            "auth": "manage_m_adv_order"
          },
          "children": [
            {
              "path": "/ad",
              "name": "ad-order",
              "meta": {
                "title": "广告订单",
                "hidden": false,
                "auth": "menu_order"
              },
            },
            {
              "path": "/workbench/someoneOrders",
              "name": "SomeoneOrders",
              "meta": {
                "title": "与我相关",
                "hidden": false,
                "auth": "view_the_sale_order"
              },
            },
            {
              "path": "/ad_wcm_live",
              "name": "ad_wcm_live",
              "meta": {
                "title": "直播数据",
                "hidden": false,
                "auth": "live_guarantee_manage"
              },
              "children": [
                {
                  "path": "/order/live-guarantee-list",
                  "name": "OrderLiveGuaranteeList",
                  "meta": {
                    "title": "直播数据池",
                    "hidden": false,
                    "keepAlive": false,
                    "auth": "live_guarantee__list_pool"
                  }
                },
                {
                  "path": "/order/live-guarantee-list-claim",
                  "name": "OrderLiveGuaranteeListClaim",
                  "meta": {
                    "title": "直播保量认领",
                    "hidden": false,
                    "keepAlive": false,
                    "auth": "live_guarantee__list_claim"
                  }
                },
                {
                  "path": "/order/live-guarantee-stat",
                  "name": "OrderLiveGuaranteeStat",
                  "meta": {
                    "title": "直播保量汇总",
                    "hidden": false,
                    "keepAlive": false,
                    "auth": "live_guarantee__list_stat"
                  }
                },
                {
                  "path": "/order/live-guarantee-list-commission",
                  "name": "OrderLiveGuaranteeListCommission",
                  "meta": {
                    "title": "直播佣金认领",
                    "hidden": false,
                    "keepAlive": false,
                    "auth": "live_guarantee__list_claim_rebate"
                  }
                }
              ]
            },
            {
              "path": "/customer_activation",
              "name": "customer-activation",
              "meta": {
                "title": "老客激活统计",
                "hidden": false,
                "auth": "view_customer_activation"
              },
            },
            {
              "path": "/income_summary",
              "name": "IncomeSummary",
              "meta": {
                "title": "收入汇总",
                "hidden": false,
                "auth": "income_summary",
              },
            },
            {
              "path": "/income_summary/agent_confirm",
              "name": "IncomeSummaryAgentConfirm",
              "meta": {
                "title": "经纪人确认",
                "hidden": false,
                "auth": "income_agent_confirm",
              },
            }, {
              "path": "/income_summary/assistant_confirm",
              "name": "IncomeSummaryAssistantConfirm",
              "meta": {
                "title": "经纪人确认（助）",
                "hidden": false,
                "auth": "income_assistant_confirm",
              },
            },
            {
              "path": "/sale_target/setting",
              "name": "SaleTargetSetting",
              "meta": {
                "title": "销售目标设定",
                "hidden": false,
                "auth": "sale_target_setting",
              },
            },
          ]
        },
        {
          "path": "/payRecord",
          "meta": {
            "title": "回款管理",
            "hidden": false,
            "keepAlive": false,
            "icon": "iconfont icon-zhangdan-tianchong",
            "icon_active": "iconfont icon-zhangdan-tianchong",
            "auth": "manage_menu_pay_record"
          },
          "children": [
            {
              "path": "/payRecord/index",
              "name": "payRecord-index",
              "meta": {"title": "回款记录", "hidden": false, "keepAlive": false, "auth": "page_pay_record"}
            },
            {
              "path": "/payRecord/tick",
              "name": "payRecord-tick",
              "meta": {"title": "回款认领", "hidden": false, "keepAlive": false, "auth": "page_tick_pay_record"}
            },
            {
              "path": "/payRecord/exception",
              "name": "payRecord-exception",
              "meta": {"title": "异常回款", "hidden": false, "keepAlive": false, "auth": "account_exception_module_list"}
            }
          ]
        },
        {
          "path": "/bill",
          "name": "bill",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "发票管理",
            "icon": "el-icon-order",
            "icon_active": "el-icon-order-active",
            "auth": "menu_invoice_application"
          },
          "children": [
            {
              "path": "/bill/index",
              "name": "bill-index",
              "meta": {"title": "发票列表", "hidden": false, "keepAlive": false, "auth": "can_invoice_application_list"}
            },
            {
              "path": "/bill/apply",
              "name": "apply-invoice",
              "meta": {"title": "申请开票", "hidden": false, "keepAlive": false, "auth": "can_invoice_apply"}
            },
            {
              "path": "/bill/commission",
              "name": "commission-invoice",
              "meta": {"title": "佣金开票", "hidden": false, "keepAlive": false, "auth": "can_invoice_commission"}
            },
            {
              "path": "/bill/my",
              "name": "bill-my",
              "meta": {"title": "我的发票", "hidden": false, "keepAlive": false, "auth": "can_invoice_my_apply"}
            }
          ]
        },
        {
          "path": "/sysSet",
          "name": "sysSet",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "系统设置",
            "icon": "el-icon-set",
            "icon_active": "el-icon-set-active",
            "auth": "system_manage"
          },
          "children": [
            {
              "path": "/sysSet/user",
              "name": "user",
              "meta": {"title": "用户管理", "hidden": false, "keepAlive": false, "auth": "user_manage"}
            },
            {
              "path": "/sysSet/organization",
              "name": "organization",
              "meta": {"title": "组织架构", "hidden": false, "keepAlive": false, "auth": "organization_manage"}
            },
            {
              "path": "/sysSet/role",
              "name": "role",
              "meta": {"title": "角色管理", "hidden": false, "keepAlive": false, "auth": "role_manage"}
            },
            {
              "path": "/sysSet/basicSetting",
              "name": "basicSetting",
              "meta": {"title": "基础配置", "hidden": false, "keepAlive": false, "auth": "setting_manage"}
            },
            {
              "path": "/sysSet/dingtalk",
              "name": "dingtalk",
              "meta": {"title": "钉钉配置", "hidden": false, "keepAlive": false, "auth": "normal"}
            },
            {
              "path": "/sysSet/feishu",
              "name": "feishu",
              "meta": {"title": "飞书配置", "hidden": false, "keepAlive": false, "auth": "feishu_manage"}
            },
            {
              path: '/sysSet/feishuBitable',
              name: 'feishuBitable',
              "meta": {"title": "飞书多维表格", "hidden": false, "keepAlive": false, "auth": "feishu_bit_manage"}
            },
            {
              "path": "/sysSet/dept",
              "name": "dept",
              "meta": {"title": "钉钉部门", "hidden": false, "keepAlive": false, "auth": "normal"}
            },
            {
              "path": "/sysSet/bridgeLog",
              "name": "bridgeLog",
              "meta": {"title": "桥接请求日志", "hidden": false, "keepAlive": false, "auth": "bridge_log_manage"}
            },
            {
              "path": "/sysSet/dingtalkUser",
              "name": "dingtalkUser",
              "meta": {"title": "钉钉用户", "hidden": false, "keepAlive": false, "auth": "normal"}
            },
            {
              "path": "/sysSet/whitelist",
              "name": "whiteList",
              "meta": {"title": "白名单", "hidden": false, "keepAlive": false, "auth": "normal"}
            },
            {
              "path": "/sysSet/resetPassword",
              "name": "resetPassword",
              "meta": {"title": "重置密码", "hidden": true, "keepAlive": false, "auth": "normal"}
            }
          ]
        },
        {
          "path": "/productReview",
          "name": "productReview",
          "meta": {
            "requiresAuth": true,
            "hidden": false,
            "title": "产品审查",
            "icon": "el-icon-share",
            "icon_active": "el-icon-set-active",
            "auth": "product_review"
          },
          "children": [
            {
              "path": "/productReview/specialFood",
              "name": "specialFood",
              "meta": {
                "title": "特殊食品",
                "hidden": false,
                "keepAlive": false,
                "auth": "special_food",
                "isExternal": true,
                "link": "http://ypzsx.gsxt.gov.cn/specialfood/#/food"
              }
            },
            {
              "path": "/productReview/prcCosmeticFiling",
              "name": "prcCosmeticFiling",
              "meta": {
                "title": "化妆品",
                "hidden": false,
                "keepAlive": false,
                "auth": "prc_cosmetic_filing",
                "isExternal": true,
                "link": "https://www.nmpa.gov.cn/datasearch/home-index.html#category=hzp"
              },
            },
          ]
        },
        {
          "path": "/personal/updateInfo",
          "name": "updateInfo",
          "meta": {"title": "基本资料", "hidden": true, "auth": "normal"}
        },
      ],
      navTitle: null
    }
  },
  watch: {
    userPermissions: {
      handler() {
        this.hiddenPaddle()
      },
      // 深度观察监听
      deep: true
    },
    "style.paddle"() {
      this.hiddenPaddle()
    },
    "screenWidth"() {
      this.hiddenPaddle()
    }
  },
  methods: {
    //计算主菜单的名称
    calcMenuTitle(menuItem) {
      let title = ''
      //若是子菜单被选中，则线上子菜单名称
      if (menuItem.children && menuItem.children.length > 0) {
        const menu = menuItem.children.find(value => value.path === this.routePath)
        // title = menu ? menu.meta.title + '-1' : menuItem.meta.title + '-2';
        if (menu) {
          title = menu.meta.title
        } else {
          let child = false
          menuItem.children.forEach((i) => {
            if (i && i.children) {
              const data = i.children.find(value => value.path === this.routePath)
              if (data) {
                title = data.meta.title
                child = true
                this.navTitle = title
              }
            } else {
              title = child ? this.navTitle : menuItem.meta.title
            }
          })
        }
      } else {
        title = menuItem.meta ? menuItem.meta.title : '';
      }
      return title


    },
//选中子菜单
    selectedMenu(menuItem) {
      //若是子菜单被选中，则线上子菜单名称
      if (menuItem.children && menuItem.children.length > 0) {
        const menu = menuItem.children.find(value => value.path === this.routePath)
        return !!menu
      } else {
        return menuItem.path === this.routePath
      }
    }
    ,
    goRoute(path) {
      this.$router.push(path)
    },
    setContainerWidth() {
      const screenWidth = document.body.clientWidth
      let containerWidth = 0
      if (screenWidth < 1300) {
        containerWidth = 760
      } else if (screenWidth < 1400) {
        containerWidth = 850
      } else if (screenWidth < 1500) {
        containerWidth = 900
      }
      this.style.containerWidth = containerWidth
      this.screenWidth = screenWidth
      this.hiddenPaddle();
    },
    handelPaddle(cmd) {
      if (cmd === 'left') {
        this.style.paddle = 'right'
        this.$refs.container && (this.$refs.container.scrollLeft = 0)
      } else {
        this.style.paddle = 'left'
        const total_menu_size = this.$refs.elMenu.$el.scrollWidth
        this.$refs.container && (this.$refs.container.scrollLeft = total_menu_size - this.style.containerWidth)
        this.style.left = total_menu_size - this.style.containerWidth
      }
    },
    hiddenPaddle() {
      setTimeout(() => {
        const containerWidth = this.style.containerWidth
        const total_menu_size = this.$refs.elMenu.$el.scrollWidth
        if (containerWidth === 0 || total_menu_size <= (containerWidth)) {
          this.style.hiddenLeft = true
          this.style.hiddenRight = true
          return;
        }

        this.style.hiddenRight = this.style.paddle === 'left' || !this.style.containerWidth
        this.style.hiddenLeft = !this.style.hiddenRight
      }, 1)
    },

  },
  mounted() {
    this.setContainerWidth()
    const that = this
    window.onresize = () => {
      return (() => {
        this.style = {
          paddle: 'right',
          containerWidth: 0,
          left: 0,
          hiddenLeft: true,
          hiddenRight: true,
        }
        this.$refs.container && (this.$refs.container.scrollLeft = 0)
        that.setContainerWidth()
      })()
    }
  },
}
</script>

<style lang="scss" scoped>

.el-menu--horizontal > .el-menu-item {
  height: 64px;
}

.new-menu {
  ::v-deep {
    .el-badge__content {
      transform: scale(0.63333);
      transform-origin: 0 0;
      top: 15px;
      right: -24px;
    }
  }
}

</style>
<style lang="scss">
.nav-menu-container {
  //width: 850px;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  display: inline-block;

  .d-flex-row {
    display: inline-flex;
  }

  .paddles {
    .paddle {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 3em;
      background: #FFF;
      cursor: pointer;


      display: inline-block;
      text-align: center;
      line-height: 65px;
    }

    .paddle:hover {
      background: rgb(224, 63, 61);
      color: #FFF;
    }

    .left-paddle {
      left: 0;
      box-shadow: 10px 0 10px rgba(255, 255, 255, 0.9)
    }

    .right-paddle {
      right: 0;
      box-shadow: -10px 0px 10px rgba(255, 255, 255, 0.95);
    }
  }

  .hidden {
    display: none !important;
  }

  .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    margin-left: 0;
  }

  .el-submenu {
    i {
      margin-right: 4px;
    }
  }


  .custom-menu-title {
    display: flex;
    align-items: center;
  }


  .el-submenu__title, .el-menu-item {
    padding: 0 15px;
  }

  .menu-item {
    .el-submenu__title {
      display: flex;
      align-items: center;
    }
  }
}

ul.el-menu--popup {
  padding: 8px 4px;
}
</style>
